import React, { useState, useEffect } from "react";
import ReactMapboxGl, { GeoJSONLayer } from "react-mapbox-gl";

import LayerFilter from "./layer_filter";

const token =
  "pk.eyJ1Ijoia2F2bmkiLCJhIjoiY2s5YjBqNGY1MGV4aTNobnk0amJncWZweCJ9.gZK_r9CYmb6ZN_mZVmgjNg";
const exposureMapRawStyle = "mapbox://styles/kavni/ckfl15v2y3tot19voewek2433";

const windowHeight = window.innerHeight;
const windowWidth = window.innerWidth;
let minzoom = 11.3;
if (windowHeight > 800 && windowWidth > 450) {
  minzoom = 12.3;
} else if (800 > windowHeight && windowHeight > 700 && windowWidth > 450) {
  minzoom = 11.9;
} else if (windowWidth < 450) {
  minzoom = 11.5;
}

const Map = ReactMapboxGl({
  accessToken: token,
  minZoom: minzoom,
  maxZoom: 16,
  logoPosition: "bottom-right",
});

const mapStyles = {
  mapStyle: {
    width: "100vw",
    height: "100vh",
  },
  mapContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
  },
};
const TlvCoronaMap = ({ layerData }) => {
  const [zoom] = useState([minzoom]);
  const [center] = useState([34.7817131, 32.0869162]);
  const [flyOverData, setFlyOverData] = useState(false);
  const [map, setMap] = useState();

  const onFlyOver = (e, layer) => {
    if (layer.fillOnMouseMove) {
      const property = layer.fillOnMouseMove;
      setFlyOverData({
        [layer.flyOverId]: Math.round(e.features[0].properties[property]),
      });
    }
  };

  return (
    <div>
      <LayerFilter
        layers={layerData}
        flyOverData={flyOverData}
        setFlyOverData={setFlyOverData}
        map={map}
      />
      <div style={mapStyles.mapContainer}>
        <Map
          style={exposureMapRawStyle}
          center={center}
          containerStyle={mapStyles.mapStyle}
          onStyleLoad={setMap}
          zoom={zoom}
        >
          {layerData.map((layer) => (
            <GeoJSONLayer
              {...layer}
              key={layer.id}
              fillOnMouseMove={(e) => onFlyOver(e, layer)}
            ></GeoJSONLayer>
          ))}
        </Map>
      </div>
    </div>
  );
};

export default TlvCoronaMap;
